import { render, staticRenderFns } from "./TemplateRiskInput.vue?vue&type=template&id=79e9f12f&scoped=true&"
import script from "./TemplateRiskInput.vue?vue&type=script&lang=js&"
export * from "./TemplateRiskInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e9f12f",
  null
  
)

export default component.exports